import { CalibrationStatus } from '@models/record-status';

export interface IVintageRunOffResponse {
  VintageRunOffs: IVintageRunOff[];
  VintageRunOffSchedule: IVintageRunOffSchedule[];
}

export interface IVintageRunOff {
  BetaCalibrationId: number;
  BetaCalibrationStatus: CalibrationStatus;
  Curtailment: number;
  DateFrom: string;
  DateTimeCreated: string;
  DateTimeModified: string;
  DateTo: string;
  DecayCalibrationId: number;
  DecayCalibrationStatus: CalibrationStatus;
  FormId: string;
  MarketRateId: number;
  PreVintageTreatment: number;
  ProductId: number;
  RunOffType: VintageRunOffType;
  StableBalanceCalibrationId: number;
  StableBalanceCalibrationStatus: CalibrationStatus;
  StartVintage: string;
  UserIdCreated: number;
  UserIdModified: number;
  VintageRunOffId: number;
  LastObservationDate: string;
  VintageRunOffTimeSeries: IVintageRunOffTimeSeriesItem[];
}

export interface IVintageRunOffTimeSeriesItem {
  Age: number;
  CouponRate: number;
  Id: number;
  MarketRate: number;
  NonStableBalance: number;
  NonStablePerCent: number;
  PeriodEndDate: string;
  PreVintageBalance: number;
  RunOffNonStableBalances: number[];
  //   RunOffPreVintageBalances: number[];
  RunOffStableBalances: number[];
  StableBalance: number;
  TotalBalance: number;
  VintageRunOffId: number;
  RunOffBalances: number[];
  DecayFactor: number;
}

export interface IVintageRunOffSchedule {
  ProductId: number;
  AsOfDate: string;
  VintageRunOffScheduleId: number;
  RunOffType: VintageRunOffType;
  EOPBalance: number;
  AvgBalance: number;
  NonStableBalance: number;
  WAL: number;
  StableBalanceWAL: number;
  Curtailment: number;
  BetaCalibrationId: number;
  BetaCalibrationStatus: CalibrationStatus;
  DecayCalibrationId: number;
  DecayCalibrationStatus: CalibrationStatus;
  StableBalanceCalibrationId: number;
  StableBalanceCalibrationStatus: CalibrationStatus;
  VintageRunOffScheduleItems: IVintageRunOffScheduleItem[];
}

export interface IVintageRunOffScheduleItem {
  ItemId: number;
  VintageRunOffScheduleId: number;
  Period: number;
  PeriodEndDate: string;
  VintageRunOff: number;
  StableBalanceRunOff: number;
  NonStableBalanceRunOff: number;
  BalanceRunOff: number;
  PrinCashFlowSchedAmount: number;
  PrinCashFlowSchedPercent: number;
}

export enum VintageRunOffType {
  ActiveActual = 1,
  ActiveForecast = 2,
  ProposedActual = 4,
  ProposedForecast = 8
}
